import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import {
  Card,
  CardContent,
  Modal,
  Box,
  Button,
  Typography,
  Chip,
  Link as MuiLink,
} from "@mui/material";

import { EventOutlined } from "@material-ui/icons";

const ListEventsModal = ({ events }) => {
  const [open, setOpen] = useState(false);

  const toggleOpen = () => setOpen(!open);

  const handleClose = () => setOpen(false);

  return (
    <>
      <MuiLink
        onClick={toggleOpen}
        sx={{ cursor: "pointer", textDecoration: "none" }}
      >
        Show Events
      </MuiLink>

      <Modal open={open} onClose={handleClose}>
        <Card
          data-testid="modal-keyword-listEvents"
          sx={{
            maxWidth: { xs: "90%", sm: "400px", md: "500px" },
            maxHeight: { xs: "400px", sm: "500px" },
            overflow: "auto",
            m: "10% auto 0 auto",
          }}
        >
          <CardContent>
            <Typography variant="h6" sx={{ mb: 1.3 }}>
              Associated Events
            </Typography>

            {events.length > 0 &&
              events.map((event, i) => {
                const [clientID, eventID] = event.split("_");

                return (
                  <Link to={`/events/?eventID=${eventID}&tab=keywords`} key={i}>
                    <Chip
                      sx={{
                        mr: 1,
                        mb: 1,
                        mt: 1,
                        cursor: "pointer",
                      }}
                      label={eventID}
                      size="small"
                      icon={<EventOutlined />}
                    />
                  </Link>
                );
              })}
          </CardContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              p: 2,
            }}
          >
            <Button onClick={handleClose}>Close</Button>
          </Box>
        </Card>
      </Modal>
    </>
  );
};

ListEventsModal.propTypes = {
  events: PropTypes.array.isRequired,
};

export default ListEventsModal;
